
<template>
  <div>
    <Head title="會員中心 - 獎勵/購物金查詢 - 各期明細" />
    <rebate-template title="會員中心">
      <template #header>
        <Link
          :href="route('user.rebates')"
          class="flex flex-row items-center text-lg"
        >
          <i class="pi pi-chevron-left mr-2" /> 獎勵/購物金查詢
        </Link>
        <div class="text-center">
          <template v-if="cv_type == 'cvt'">當期C.V.T.明細</template
          ><template v-else>當期C.V.明細</template>
        </div>
      </template>

      <main v-if="details.length > 0">
        <div class="rebates_record" :key="detail.id" v-for="detail in details">
          <div>
            <div class="label">時間</div>
            {{ dayjs(detail.created_at).format("YYYY/MM/DD HH:mm:ss") }}
          </div>

          <div>
            <div class="label">說明</div>
            {{ detail.description }}
          </div>

          <div class="cv">
            <div class="label">CV</div>
            <span :class="{ 'text-red': detail.amount < 0 }">{{
              detail.amount | commaFormat
            }}</span>
          </div>
        </div>
      </main>
      <main v-else>
        <div class="text-center">沒有任何明細資料。</div>
      </main>
    </rebate-template>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import RebateTemplate from "./Shared/RebateTemplate";

export default {
  components: {
    RebateTemplate,
  },
  filters: {
    commaFormat: function (value) {
      return value
        .toString()
        .replace(
          /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
          function (all, pre, groupOf3Digital) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
          }
        );
    },
  },
  layout: Layout,
  computed: {
    cv_type() {
      if (
        this.$page.props.auth.user &&
        this.$page.props.auth.user.level == 1 &&
        !this.$page.props.auth.user.attributes?.degraded_at &&
        (this.$page.props.rules.regular?.cv?.checked ||
          this.$page.props.rules.regular?.referral?.checked)
      ) {
        // 一般會員
        if (this.$page.props.rules.regular?.cv?.referred) return "cvt";
      }

      if (
        this.$page.props.auth.user &&
        this.$page.props.auth.user.level == 2 &&
        (this.$page.props.rules.upgraded?.cv?.checked ||
          this.$page.props.rules.upgraded?.referral?.checked)
      ) {
        // 推廣會員
        if (this.$page.props.rules.upgraded?.cv?.referred) return "cvt";
      }

      if (
        this.$page.props.auth.user &&
        this.$page.props.auth.user.level == 1 &&
        this.$page.props.auth.user.attributes?.degraded_at &&
        (this.$page.props.rules.degraded?.cv?.checked ||
          this.$page.props.rules.degraded?.referral?.checked)
      ) {
        //一般會員升回推廣會員
        if (this.$page.props.rules.degraded?.cv?.referred) return "cvt";
      }

      return "cv";
    },
    details() {
      if (this.cv_type == "cv") {
        return this.$page.props.current.filter((item) => {
          return !item.reference.event.includes("referred_");
        });
      } else {
        return this.$page.props.current;
      }
    },
  },
  data() {
    return {
      //
    };
  },
};
</script>

<style lang="postcss">
.rebates_record {
  @apply flex justify-between flex-col md:flex-row border border-fh-gray-border items-center p-5 m-2 gap-2;
}

.rebates_record .cv {
  @apply flex flex-row flex-nowrap gap-2 items-center w-24;
}

.rebates_record .label {
  @apply text-sm whitespace-nowrap;
}
</style>